import { render } from "./CKPachong.vue?vue&type=template&id=b36fa5b8"
import script from "./CKPachong.vue?vue&type=script&lang=js"
export * from "./CKPachong.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__